// extracted by mini-css-extract-plugin
export var course = "reviews-module--course--59412";
export var name = "reviews-module--name--aae5e";
export var reviews = "reviews-module--reviews--7ab81";